import { render, staticRenderFns } from "./BaseQuick.vue?vue&type=template&id=4c1cdbab&scoped=true"
import script from "./BaseQuick.vue?vue&type=script&lang=js"
export * from "./BaseQuick.vue?vue&type=script&lang=js"
import style0 from "./BaseQuick.vue?vue&type=style&index=0&id=4c1cdbab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1cdbab",
  null
  
)

export default component.exports